import {DocumentNode, gql} from "@apollo/client";

export const CHECK_PAYMENT_MUTATION: DocumentNode = gql(`
    mutation CheckPayment($operationId: Float!) {
        checkPayment(operationId: $operationId) {
            message
        }
    }
`);
